module.exports = __webpack_public_path__ + "img/14.e10c8def.jpg";